import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginUser } from '../redux/auth/authSlice';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});  
  const [token, setToken] = useState('GBHYUNLM432LMNHGBYR76%#@89Ughtfr');

  const validateForm = () => {
    let formErrors = {};
    if (!email) formErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(email)) formErrors.email = 'Invalid email';

    if (!password) formErrors.password = 'Password is required';
    else if (password.length < 6) formErrors.password = 'Password must be at least 6 characters';

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const result = await dispatch(loginUser({ email, password, token}));
    if (result.meta.requestStatus === 'fulfilled') {
      toast.success('Login successful');
      navigate('/dashboard');
    } else {
      toast.error(result.payload);
    }
  };
  return (
    <section className="herobanner_sec">
      <div className='container-fluid'>
        <div className="canvars_wrapper pb-0">
          <h5 className="f700 text-center mb-3">Login to your Account</h5>
          <form onSubmit={handleSubmit}>
          <ul className="pb-0 mb-0">
            <li className="inputLi"><input type="email" className="inputBox" placeholder="user@email.com" value={email} onChange={(e) => setEmail(e.target.value)} /> 
            {errors.email && <p className='mb-0 pb-0' style={{ color: 'red' }}>{errors.email}</p>}</li>
            <li className="inputLi"><input type="password" className="inputBox" placeholder="Password"value={password} onChange={(e) => setPassword(e.target.value)} />
            {errors.password && <p className='mb-0 pb-0' style={{ color: 'red' }}>{errors.password}</p>} </li>
            <li><button className="signinbtn my-3 active">{loading ? 'Logging in...' : 'Sign in with email'}</button></li>
          </ul>
          {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
          </form>
          <p className="small text-center text-black-50">By proceeding, you agree to our Terms and <br/>acknowledge our <a target="_blank" rel="noreferrer" href="https://www.stellarinfo.com/company/legal/privacy-policy.php" style={{ color: "rgb(85, 85, 85)", textDecoration: "underline" }}>Privacy Policy</a></p>
          </div>
      </div>
    </section>
  )
}

export default Login